import CountdownCentered from './CountdownCentered';
import CountdownLuxe from './CountdownLuxe';

const VARIANTS = {
  'countdown-centered': CountdownCentered,
  'countdown-luxe': CountdownLuxe,
};

export default function CountdownSection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || CountdownCentered;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
